<template>
  <div>
    <wc-data-box
      :title='title'
      titleIcon='mdi-currency-usd'
      titleIconColor='success'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td>Base Price</td>
            <td class='text-right' v-if='detail.driveway_rating'>
              {{ obj.costs.base_price | decMoney }}
            </td>
            <td class='text-right' v-else>
              No driveway rating
            </td>
          </tr>
          <tr>
            <td>Quickpay fee</td>
            <td class='text-right'>
              {{ obj.costs.quickpay_fee | decMoney }}
            </td>
          </tr>
          <tr>
            <td>Rock Chip Fee</td>
            <td class='text-right'>
              {{ obj.costs.ice_melt_fee | decMoney }}
            </td>
          </tr>
          <tr>
            <td>Lawn Signs Discount</td>
            <td class='text-right'>
              ({{ obj.costs.lawn_signs_discount | decMoney }})
            </td>
          </tr>
          <tr>
            <td>Base Subtotal</td>
            <td class='text-right'>
              {{ obj.costs.base_subtotal | decMoney}}
            </td>
          </tr>
          <tr>
            <td>Duration <small class='grey--text'>(rounded)</small></td>
            <td class='text-right'>
              {{ obj.costs.duration }} months
            </td>
          </tr>
          <tr>
            <td>
              Base Total
              <small class='grey--text'> rounded down</small>
            </td>
            <td class='text-right'>
              {{ obj.costs.base_total | decMoney }}
            </td>
          </tr>
          <tr>
            <td>
              Billing Discount
              <small class='grey--text'> 1/2 base subtotal</small>
            </td>
            <td class='text-right'>
              <span v-if='obj.costs.full_payment_discount > 0'>({{ obj.costs.full_payment_discount | decMoney }})</span>
              <span v-else>-</span>
            </td>
          </tr>
          <tr class='font-weight-bold'>
            <td class=''>Subtotal</td>
            <td class='text-right'>
              {{ obj.costs.total | decMoney }}
            </td>
          </tr>
          <tr class='font-weight-bold'>
            <td class=''>GST</td>
            <td class='text-right'>
              {{ obj.costs.gst | decMoney }}
            </td>
          </tr>
          <tr>
            <td class='py-3 headline '>TOTAL</td>
            <td class='py-3 headline text-right'>
              {{ obj.costs.grand_total | decMoney }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

  </div>
</template>

<script>

export default {
  name: 'estimate-totals',
  props: {
    obj: {
      required: true
    },
    title: {
      required: false,
      type: String,
      default: "Quote Total"
    }
  },
  watch: {
    obj () {
      console.log('changed...')
    }
  },
  computed: {
    detail () {
      if ('project_detail' in this.obj) {
        return this.obj.project_detail
      } else {
        return this.obj.estimate_detail
      }
    }
  },
  data: () => ({

  }),
  methods: {

  }
}
</script>

